import { render, staticRenderFns } from "./PatientHeader.vue?vue&type=template&id=0c3ed060&scoped=true"
import script from "./PatientHeader.vue?vue&type=script&lang=js"
export * from "./PatientHeader.vue?vue&type=script&lang=js"
import style0 from "./PatientHeader.scss?vue&type=style&index=0&id=0c3ed060&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3ed060",
  null
  
)

export default component.exports